<div class="grid mt-4 d-flex align-items-baseline" [formGroup]="codeForm">
  <div class="field col-12 md:col-3">
    <p-floatlabel>
      <p-select inputId="location" class="w-100" [options]="locationService.locations" optionValue="id"
        (ngModelChange)="lookupCode()" formControlName="location" optionLabel="city"></p-select>
      <label [for]="'location'">Ausgabeort</label>
    </p-floatlabel>
  </div>

  <div class="field col-12 md:col-5">
    <p-floatlabel>
      <input id="code" class="w-100" type="text" formControlName="codeValue" (ngModelChange)="lookupCode()"
        pInputText />
      <label for="code">Nutzernummer</label>
    </p-floatlabel>
  </div>

  <div class="field col-11 md:col-2">
    <p-floatlabel>
      <p-select inputId="rotation" class="w-100" [options]="[0,1,2]" (ngModelChange)="lookupCode()"
      formControlName="rotation"></p-select>
      <label [for]="'rotation'">Turnus</label>
    </p-floatlabel>
  </div>

  <div class="col-2 d-flex justify-content-center align-items-center">
    @if (!checkingCode && free) {
      <i class="pi pi-check mr-2"></i>
    }
    @if (!checkingCode && !free) {
      <i class="pi pi-times mr-2"></i>
    }
    @if (checkingCode) {
      <i class="pi pi-spinner loading-spinner mr-2"></i>
    }
    <p-button class="ml-2" icon="pi pi-trash"
    [outlined]="true" [rounded]="true" (onClick)="removeCode()"></p-button>
  </div>

  @if (codeDirty) {
    <div class="col-12 d-flex justify-content-end">
      @if (!checkingCode && free) {
        <p>Nutzernummer ist zugewiesen</p>
      }
      @if (!checkingCode && !selectedCode) {
        <p>Nutzernummer existiert nicht</p>
      }
      @if (!checkingCode && selectedCode && !free) {
        <p>
          Nutzernummer ist aktuell vergeben.
          @if (upcoming) {
            <p-button link (click)="forceCodeUsage($event)">
              Trotzdem verwenden?
            </p-button>
          }
        </p>
      }
    </div>
  }

  <div class="field col-12 md:col-6">
    <p-floatlabel>
      <p-select inputId="weekday" class="w-100" [options]="weekdayService.weekdays" optionValue="id"
      formControlName="weekday" optionLabel="title"></p-select>
      <label [for]="'weekday'">Wochentage</label>
    </p-floatlabel>
  </div>

  <div class="field col-12 md:col-6">
    <p-floatlabel>
      <p-date-picker class="w-100" [timeOnly]="true" hourFormat="24" formControlName="time"
      inputId="distribution_time"></p-date-picker>
      <label [for]="'distribution_time'">Ausgabezeit</label>
    </p-floatlabel>
  </div>
</div>
